module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-can-request"
  }, [_c('ButtonDefault', _vm._b({
    attrs: {
      "size": _vm.size,
      "color": _vm.color,
      "disabled": _vm.disabled,
      "factor": _vm.factor,
      "block": _vm.block
    },
    on: {
      "click": _vm.onClick
    }
  }, 'ButtonDefault', _vm.$attrs, false), [_vm._t("default", [_vm._v(_vm._s(_vm.text))])], 2), _c('div', {
    staticClass: "btn-can-request__tooltip",
    class: {
      'btn-can-request__tooltip_on': _vm.disabledRequest && !_vm.offTooltip
    },
    on: {
      "click": _vm.tooltipClick
    }
  }, [_vm._v(_vm._s(_vm.requestTooltipText))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ae4c0e5","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/presets/button/can-request/component.vue
// module id = d737e9cf29db3e2ad7f6
// module chunks = 0